import React from 'react';
import { Button } from './ui/Button';
import { WaveDivider } from './WaveDivider';
export function ReadyToBook() {
  return <section id="booking-form" className="relative bg-[#FFB5C5] pt-20 pb-0" data-id="element-156">
      <div className="container mx-auto px-4 md:px-8 pb-32" data-id="element-157">
        <div className="max-w-4xl mx-auto text-center" data-id="element-158">
          <h2 className="text-6xl md:text-8xl font-bold mb-8 text-[#1a1a1a]" data-id="element-159">
            Ready to Book?
          </h2>
          <p className="text-xl text-gray-800 mb-12" data-id="element-160">
            Check availability for your date and secure your vintage audio guest
            book today.
          </p>

          <form className="bg-white/30 backdrop-blur-md p-8 rounded-3xl shadow-xl border border-white/50 max-w-2xl mx-auto text-left" data-id="element-161">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-162">
              <div data-id="element-163">
                <label className="block text-sm font-bold mb-2 ml-1" data-id="element-164">
                  Name
                </label>
                <input type="text" className="w-full px-4 py-3 rounded-xl border-none bg-white/80 focus:ring-2 focus:ring-black transition-all" placeholder="Your name" data-id="element-165" />
              </div>
              <div data-id="element-166">
                <label className="block text-sm font-bold mb-2 ml-1" data-id="element-167">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-3 rounded-xl border-none bg-white/80 focus:ring-2 focus:ring-black transition-all" placeholder="hello@example.com" data-id="element-168" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-169">
              <div data-id="element-170">
                <label className="block text-sm font-bold mb-2 ml-1" data-id="element-171">
                  Event Date
                </label>
                <input type="date" className="w-full px-4 py-3 rounded-xl border-none bg-white/80 focus:ring-2 focus:ring-black transition-all" data-id="element-172" />
              </div>
              <div data-id="element-173">
                <label className="block text-sm font-bold mb-2 ml-1" data-id="element-174">
                  Event Location
                </label>
                <input type="text" className="w-full px-4 py-3 rounded-xl border-none bg-white/80 focus:ring-2 focus:ring-black transition-all" placeholder="City, State" data-id="element-175" />
              </div>
            </div>

            <div className="flex justify-center mt-8" data-id="element-176">
              <Button variant="black" className="w-full md:w-auto px-12 py-4 text-lg" data-id="element-177">
                Check Availability
              </Button>
            </div>
          </form>
        </div>
      </div>

      <WaveDivider fill="#000000" direction="up" className="absolute bottom-0 w-full" data-id="element-178" />
    </section>;
}